import { useCallback, useEffect, useRef } from 'react';

import { loadPlateLoadShape, type PlateLoadShape } from './state/plateConfig';

/** The load shape the athlete SAVED for `slug`, read async from the same store
 *  as the plan hydration and the swap; it wins over the catalog's
 *  (`resolveLoadShape`). Returns a reader: null until the store answered for
 *  that slug, so a caller gets the catalog's shape meanwhile. Extracted from
 *  useCommitSet (#539: the AMRAP test floors on it too). */
export function useStoredLoadShape(
  slug: string | undefined,
): (forSlug: string) => PlateLoadShape | null {
  const storedRef = useRef<{ slug: string; shape: PlateLoadShape | null } | null>(null);
  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    void loadPlateLoadShape(slug).then((shape) => {
      if (!cancelled) storedRef.current = { slug, shape };
    });
    return () => {
      cancelled = true;
    };
  }, [slug]);
  return useCallback((forSlug: string) => {
    const stored = storedRef.current;
    return stored && stored.slug === forSlug ? stored.shape : null;
  }, []);
}
